<template>
  <div :id='randomId'>
    <ejs-listview id='flat-list' ref="listNe" :dataSource='data' :filterCode="typeCode"></ejs-listview>
  </div>
</template>

<script>
import { EventBus } from '../../plugins/eventBus.js';
export default {
  name: 'NeList',
  props: [
    'neArr',
    'select',
    'keywords',
    'typeCode',
  ],
  data() {
    return {
      data: [],
      primaryDatas: [],
      $formId: '',
    };
  },
  computed: {
    randomId() {
      const _temp = 'abcdefghijklmnopqrstuvwxyz';
      this.$formId = '';
      for (let i = 0; i < 5; i++) {
        this.$formId += _temp[Math.round(Math.random(1) * 26)];
      }
      return this.$formId;
    }
  },
  methods: {
    _getNeTreeData() {
      const $this = this;
      $this.data = [];
      this.$axios.post('/lte/ems/auth/findElementListByAuth', this.neArr).then((response) => {
        const _nodeArray = response.data;
        const showData = [];
        const showPrimaryDatas = [];
        _nodeArray.forEach((_item) => {
          const { id, name, equipmentIPId, typeCode, equipmentTypeCode, physicalIP} = _item;
          const _dataItem = {
            text: `${physicalIP}-${id}-${name}`,
            id,
            neType: typeCode,
            typeCode: equipmentTypeCode,
            tooltip: `${physicalIP}-${id}-${name}`,
            equipmentIPId
          };
          if (($this.typeCode && _dataItem.typeCode !== 10006) || $this.typeCode === undefined) {
            showData.push(_dataItem);
            showPrimaryDatas.push(_dataItem);
          }
        });
        $this.data = showData;
        $this.primaryDatas = showPrimaryDatas;
      });
    },
    doSearch() {
      if (this.keywords === '') {
        this.data = this.primaryDatas;
        return;
      }
      const leftNeDatas = this.primaryDatas.filter(neData => (neData.text.includes(this.keywords)));
      this.data = leftNeDatas;
    },
    getNe() {
      return this.$refs.listNe.getSelectedItems();
    },
    getOnlineNe() {
      const $this = this;
      const node = $this.$refs.listNe.getSelectedItems();
      $this.axios.get(`/lte/ems/config/mml/queryNodeLinkStatus/${node.data.id}`).then(res => {
        const nodeStatus = res.data ? res.data.resultVal : 0;
        if (nodeStatus === 0) {
          EventBus.$emit('toast', { type: 'warning', content: $this.$t('Common.neOffLine', [node.data.text]) });
        }
      });
      return node;
    }
  },
  beforeMount() {
    this._getNeTreeData();
  },
  updated() {
    const $this = this;
    document.getElementById(this.$formId).onclick = function () {
      $this.select();
    };
  }
};

</script>

<style scoped>

</style>
